import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import rootReducer from './Reducers/Root'

const initialState = {};


const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
    rootReducer, 
    initialState, 
    composeEnhancers(applyMiddleware(thunk))
  
)

export default store; 


// WEBPACK FOOTER //
// ./src/store.js